// CustomAreaChart.jsx
import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

/**
 * CustomAreaChart
 *
 * Props:
 * - chartData: Array of data objects to display.
 * - dynamicDataKey: The key in each data object to plot (e.g., "members").
 * - xAxisKey: Key for the X axis (default is "date").
 * - yAxisTickFormatter: Function to format Y axis ticks.
 * - yAxisDomain: Domain for the Y axis (e.g., ["auto", "auto"]).
 * - CustomTooltip: Optional component for custom tooltip content.
 */
const CustomAreaChart = ({
  chartData,
  dynamicDataKey,
  xAxisKey = "date",
  yAxisTickFormatter,
  yAxisDomain,
  CustomTooltip,
  isLoading,
}) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={chartData}>
        <defs>
          <linearGradient id="auroraGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#5b9bd5" stopOpacity={1} />
            <stop offset="50%" stopColor="#4178a8" stopOpacity={0.4} />
            <stop offset="100%" stopColor="#4178a8" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="1" />
        <XAxis
          dataKey={xAxisKey}
          tick={{ fill: "#777", fontSize: 14, fontWeight: 400 }}
        />
        <YAxis
          tickFormatter={yAxisTickFormatter}
          domain={yAxisDomain}
          tick={{ fill: "#777", fontSize: 14, fontWeight: 400 }}
        />
        <Tooltip content={CustomTooltip && <CustomTooltip />} />

        <Area
          type="monotone"
          dataKey={dynamicDataKey}
          stroke="url(#underGradient)"
          fill="url(#auroraGradient)"
          dot
        />
        <Legend verticalAlign="bottom" />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default CustomAreaChart;
